import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    <div class="loading-spinner-container" [ngClass]="containerClass">
      <div class="loading-spinner-content" [ngClass]="contentClass">
        <p-progressSpinner 
          [style]="spinnerStyle" 
          [strokeWidth]="strokeWidth" 
          [animationDuration]="animationDuration"
          [styleClass]="spinnerClass">
        </p-progressSpinner>
        <!-- <p *ngIf="message" class="loading-message" [ngClass]="messageClass">{{ message }}</p> -->
      </div>
    </div>
  `,
  styles: [`
    .loading-spinner-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .loading-spinner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
    }
    
    .loading-message {
      margin: 0;
      color: #6b7280;
      font-size: 0.875rem;
      text-align: center;
    }
    
    /* Full screen overlay */
    .loading-spinner-container.full-screen {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.9);
      z-index: 9999;
    }
    
    /* Inline loading */
    .loading-spinner-container.inline {
      padding: 2rem;
    }
    
    /* Button loading */
    .loading-spinner-container.button {
      padding: 0.5rem;
    }
    
    /* Card loading */
    .loading-spinner-container.card {
      padding: 3rem;
    }
    
    /* Table loading */
    .loading-spinner-container.table {
      padding: 2rem;
    }
  `]
})
export class LoadingSpinnerComponent {
  @Input() message: string = '';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() type: 'full-screen' | 'inline' | 'button' | 'card' | 'table' = 'inline';
  @Input() strokeWidth: string = '3';
  @Input() animationDuration: string = '1s';
  @Input() spinnerClass: string = '';
  @Input() messageClass: string = '';

  get containerClass(): string {
    return `loading-spinner-container ${this.type}`;
  }

  get contentClass(): string {
    return 'loading-spinner-content';
  }

  get spinnerStyle(): any {
    const sizes = {
      small: { width: '24px', height: '24px' },
      medium: { width: '48px', height: '48px' },
      large: { width: '64px', height: '64px' }
    };
    return sizes[this.size];
  }
}
